export const Fontfamilies = {
    state: {
        fontfamilies: {
            1: { id: 1, pos: 1 },
            2: { id: 2, pos: 2 },
            3: { id: 3, pos: 3 },
            4: { id: 4, pos: 4 },
            5: { id: 5, pos: 5 },
            6: { id: 6, pos: 6 },
            7: { id: 7, pos: 7 },
            8: { id: 8, pos: 8 },
            9: { id: 9, pos: 9 },
            10: { id: 10, pos: 10 },
            11: { id: 11, pos: 11 },
            12: { id: 12, pos: 12 },
            13: { id: 13, pos: 13 },
            14: { id: 14, pos: 14 },
            15: { id: 15, pos: 15 },
            16: { id: 16, pos: 16 },
            17: { id: 17, pos: 17 },
            18: { id: 18, pos: 18 },
            19: { id: 19, pos: 19 },
            20: { id: 20, pos: 20 }
        }
    },
    mutations: {},
    getters: {
        getFontfamilies(state) {
            return state.fontfamilies;
        },
        getFontfamilyDefault(state) {
            let items = Object.keys(state.fontfamilies);
            return items[Math.floor(Math.random() * items.length)];
        }
    }
};
